import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/AxiosInstance";
import { addJob, editJob, removeJob } from "./jobsApi";

const initialState = {
  error: "",
  loading: false,
  jobs: [],
};

export const fetchJobs = createAsyncThunk("jobs/fetchJobs", async () => {
  const response = await axiosInstance.get("/jobs");
  return response.data;
});

export const deleted = createAsyncThunk("jobs/deleteJobs", async (id) => {
  const response = await removeJob(id);
  return response;
});
export const edited = createAsyncThunk("jobs/editJob", async (data) => {
  const response = await editJob(data);
  return response;
});
export const added = createAsyncThunk("jobs/addJob", async (data) => {
  const response = await addJob(data);
  return response;
});

const jobsSlice = createSlice({
  name: "jobs",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.error = false;
        state.jobs = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleted.fulfilled, (state, action) => {
        state.jobs = state.jobs.filter((job) => job.id !== action.meta.arg);
      });
  },
});

export default jobsSlice.reducer;
